import { Routes } from '@angular/router';
import { Login } from './features/auth/login/login';
import { Logout } from './features/auth/logout/logout';
import { UnauthorizedAccess } from './features/auth/unauthorized-access/unauthorized-access';
import { Guia } from './features/main/components/guia/guia';
import { Home } from './home/home';
import { Profile } from './features/main/components/profile/profile';
import { Tracking } from './features/main/components/tracking/tracking';
import { AuthGroupsDirective } from './shared/directives/appAuthGroups.directive';
import { isAuthenticated } from './shared/services/auth.service';
import { Recursos } from './features/main/components/recursos/recursos';
import { Ayuda } from './home/ayuda/ayuda';

export const routes: Routes = [
    {
        path: 'perfil',
        component: Profile,
        canActivate: [isAuthenticated]
        // loadComponent() {
        //     return import('./features/report-preview/preview').then(m => m.Preview);
        // },
    },
    {
        path: 'ayuda',
        component: Ayuda,
        canActivate: [isAuthenticated]
        // loadComponent() {
        //     return import('./features/report-preview/preview').then(m => m.Preview);
        // },
    },
    {
        path: 'recursos',
        component: Recursos,
        canActivate: [isAuthenticated]
    },
    {
        path: 'tests',
        loadChildren: () =>
            import('./features/tests/tests.routes').then(m => m.ROUTES),
    },
    {
        path: 'configuracion',
        loadChildren: () =>
            import('./features/configuration/configuration.routes').then(m => m.ROUTES),
    },
    {
        path: 'clientes',
        loadChildren: () =>
            import('./features/clientes/clientes.routes').then(m => m.ROUTES),
    },
    {
        path: 'repartidor',
        loadChildren: () =>
            import('./features/repartidor/repartidor.routes').then(m => m.ROUTES),
    },
    {
        path: 'operaciones',
        loadChildren: () =>
            import('./features/operations/operations.routes').then(m => m.ROUTES),
    },
    {
        path: 'seguridad',
        loadChildren: () =>
            import('./features/security/security.routes').then(m => m.ROUTES),
    },
    {
        path: 'admin',
        loadChildren: () =>
            import('./features/admin/admin.routes').then(m => m.ROUTES),
    },
    {
        path: 'tracking',
        component: Tracking
    },
    {
        path: 'tracking/:trackingNumber',
        component: Tracking
    },
    {
        path: 'guia',
        component: Guia
    },
    {
        path: 'auth',
        children: [
            {
                path: 'login',
                component: Login
            },
            {
                path: 'logout',
                component: Logout
            }, {
                path: 'unauthorized-access',
                component: UnauthorizedAccess
            },
        ]
    },

    {
        path: '',
        pathMatch: 'full',
        component: Home,
    },
];
